module.exports = {
  "off-black": "#111111",
  "gray-dark": "#222222",
  "gray-light": "#f1f1f1",
  "gray-med": "#888888",
  "gray-line": "#dddddd",
  "dk-green": "#516C38",
}
